<template>
  <div class="">
    <el-dialog
      width="30%"
      title=""
      :visible.sync="IsShowSMS"
      :direction="direction"
      :before-close="handleClose"
    >
      <div slot="title" class="bg-primary">
        <h2 class="font-semibold fsize14 text-white mb-1">SMS Preview</h2>
      </div>
      <div>
        <div class="px-2">
          <div class="flex mt-0 mb-1 justify-between items-center">
            <h2 class="font-semibold fsize16 text-dark">{{ Title }}</h2>
            <p
              class="flerx mr-5 fsize10 px-3 py-1 rounded-full font-semibold capitalize"
              :class="{
                'text-warning bg-light-warning': status === 'pending',
                'text-success bg-light-green': status === 'approved',
                'text-danger bg-light-danger': status === 'rejected',
              }"
            >
              {{ status }}
            </p>
          </div>
          <div>
            <p class="fsize12 col-4f4f4f opacity-80">
              {{ templateBody }}
            </p>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="centerDialogVisible"
      width="35%"
      center
      class="ne-oppop"
    >
      <div class="bg-primary p-4 flex justify-between items-center">
        <h2 class="text-white fsize14 my-0">SMS Template</h2>
        <feather-icon
          icon="XIcon"
          svgClasses="w-4 h-4"
          class="cursor-pointer text-white"
          @click="
            () => {
              centerDialogVisible = false;
            }
          "
        />
      </div>
      <div class="p-4 items-center">
        <div class="flex justify-center w-full">
          <img
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
            class="new-height"
          />
        </div>

        <p class="fsize14 text-dark text-center font-medium my-4">
          Customized SMS Template is available only for other BRAINED's
          Subscription Plans. Please upgrade to other plan to access this
          feature
        </p>

        <div class="flex w-full mt-4 gap-2">
          <vs-button
            color="primary"
            class="bg-primary sm-button w-full"
            @click="
              () => {
                centerDialogVisible = false;
                this.$router.push({ name: 'plans-vue' });
              }
            "
            >Upgrade</vs-button
          >

          <vs-button
            color="secondary"
            class="bg-secondary sm-button w-full"
            @click="centerDialogVisible = false"
            >Cancel</vs-button
          >
        </div>
      </div>
    </el-dialog>
    <el-drawer
      title=""
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
    >
      <template slot="title"
        ><h3 class="text-xl Add Products text-white">
          Create SMS Template
        </h3></template
      >
      <Templatedrawer @apiCallSms="getAll" :drawer="drawer" />
    </el-drawer>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            SMS Template
          </h2>
        </div>
      </div>
    </div>

    <div class="bg-f4f5f6 p-8 menucontrol-scroll fixed-top">
      <div class="flex items-center gap-4 mb-8 justify-left">
        <div class="w-3/5">
          <p class="mb-0 font-medium">Search by Name</p>
          <div v-if="type == 'Custom'" class="flex items-center mt-2 relative">
            <el-input
              placeholder="Please input"
              v-model="templateName"
              maxlength="50"
              class="rounded-none"
            ></el-input>
            <div class="absolute top-2 right-10px mt-1">
              <feather-icon icon="SearchIcon" class="" />
            </div>
          </div>
          <div v-if="type == 'Default'" class="flex items-center mt-2 relative">
            <el-input
              placeholder="Please input"
              v-model="templateName2"
              maxlength="50"
              class="rounded-none"
            ></el-input>
            <div class="absolute top-2 right-10px mt-1">
              <feather-icon icon="SearchIcon" class="" />
            </div>
          </div>
        </div>
        <div class="w-1/4">
          <div class="w-full">
            <p class="mb-0 font-medium">Search by Type</p>
            <el-select
              v-model="type"
              placeholder=""
              class="w-full border-2 mt-2 rounded-lg"
            >
              <el-option
                v-for="item in types"
                :key="item.label"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <vs-button
          v-if="type == 'Custom'"
          variant="primary"
          class="rounded-lg bg-primary border-0 text-white mt-28 font-semibold sm-fsize14"
          @click="sidebarOpen"
        >
          Add New
        </vs-button>
      </div>
      <div v-if="type == 'Default'">
        <div class="w-full p-5 bg-white mb-8">
          <h2 class="text-xl mb-0 font-semibold">Default SMS Template</h2>
        </div>

        <div class="grid grid-cols-3 gap-8 items-start">
          <div
            class="bg-white border-round"
            v-for="(i, index) in this.defaultSmsTemps"
            :key="index"
          >
            <div class="bg-white p-6 border-btm">
              <div class="flex justify-between items-center">
                <div class="flex items-center gap-2">
                  <!-- <p
                    class="bg-primary text-white w-10 h-10 flex justify-center items-center rounded-lg mb-0"
                  >
                    {{ index + 1 }}
                  </p> -->
                  <p class="text-black fsize18 font-semibold mb-0">
                    {{ i.templateName }}
                  </p>
                  <div
                    class="p-1 rounded-full flex items-center justify-center"
                  >
                    <el-tag
                      size="mini"
                      class="rounded-full text-sm text-dark px-3 h-6"
                      >Default</el-tag
                    >
                    <feather-icon
                      svgClasses="w-4 h-4"
                      class="text-white flex"
                      icon="CheckIcon"
                    />
                  </div>
                </div>
                <feather-icon
                  @click="preview(i)"
                  svgClasses="w-4 h-4"
                  class="flex cursor-pointer"
                  icon="EyeIcon"
                />
              </div>

              <div class="mt-6">
                <p class="text-black fsize15 font-semibold">SMS Body:</p>
                <span class="text-8f8f8f font-medium">{{ i.smsBody }}</span>
                <!-- <p class="text-8f8f8f font-medium mt-4">
              To enrol, click on link below
            </p>
            <p class="text-8f8f8f font-medium mt-2">1</p> -->
              </div>
            </div>
            <!-- <p class="text-black font-semibold mt-3">Examaple:</p>
          <p class="text-8f8f8f font-medium">
            hello, this a gental you to enroll for the webinar on Brained
            Reseller Program. a gental you to enroll for the webinar on Brained
            Reseller Program.
          </p> -->
          </div>
        </div>
        <div class="w-full flex justify-end mt-6">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="
              (value) => {
                currentPage2 = value;
                getDefaultSmsTemplates();
              }
            "
            :per-size="perPage2"
            :total="totalUsers2"
          >
          </el-pagination>
        </div>
      </div>

      <div class="mt-12" v-if="type == 'Custom'">
        <div class="w-full p-5 bg-white mb-8">
          <h2 class="text-xl mb-0 font-semibold">Custom SMS Templates</h2>
        </div>

        <div class="grid grid-cols-3 gap-8 items-start">
          <div
            class="p-6 elshadow bg-white border-round"
            v-for="data in smsTemplates"
            :key="data._id"
          >
            <div class="flex justify-between items-center">
              <div class="flex items-center gap-2">
                <!-- <p
                  class="bg-primary text-white w-10 h-10 flex justify-center items-center rounded-lg mb-0"
                >
                  1
                </p> -->
                <p class="text-black fsize18 font-semibold mb-0">
                  {{ data.templateName }}
                </p>
                <div
                  class="p-1 rounded-full flex items-center justify-right"
                ></div>
                <!-- <p
                  class="fsize10 mb-0 font-semibold capitalize"
                  :class="{
                    textwarning: data.status === 'pending',
                    'text-success': data.status === 'approved',
                    textdanger: data.status === 'rejected',
                  }"
                >
                  {{ data.status }}
                </p> -->
              </div>
              <feather-icon
                @click="preview(data)"
                svgClasses="w-4 h-4"
                class="flex justify-right cursor-pointer"
                icon="EyeIcon"
              />
            </div>

            <div class="mt-6">
              <div class="flex items-center gap-2 mt-4">
                <p class="text-black fsize15 font-semibold">SenderId:</p>
                <p>{{ data.senderId ? data.senderId.sender : "" }}</p>
              </div>
              <p class="text-black fsize15 font-semibold">SMS Body:</p>

              <p class="text-8f8f8f font-medium mt-4" v-html="data.body"></p>
            </div>
            <div class="py-6 px-2">
              <el-steps
                v-if="data.status !== 'rejected'"
                class="cust-step"
                :space="200"
                :active="
                  data.canUse == true
                    ? 4
                    : data.status == 'pending'
                    ? 1
                    : data.status == 'approved'
                    ? 2
                    : 1
                "
                finish-status="success"
              >
                <el-step
                  class="cust-fsize12"
                  icon="el-icon-stopwatch"
                  title="Processed"
                ></el-step>
                <el-step
                  class="cust-fsize12"
                  icon="el-icon-stopwatch"
                  title="Approval Status"
                ></el-step>
                <el-step
                  icon="el-icon-stopwatch"
                  class="cust-fsize12"
                  title="Integration"
                ></el-step>
                <el-step
                  class="cust-fsize12"
                  icon="el-icon-stopwatch"
                  title="Delivered"
                ></el-step>
              </el-steps>
              <el-steps
                v-if="data.status == 'rejected'"
                class="cust-step"
                :space="200"
                :active="0"
                process-status="error"
              >
                <el-step
                  class="cust-fsize12"
                  icon="el-icon-stopwatch"
                  title="Rejected"
                ></el-step>
                <el-step
                  class="cust-fsize12"
                  icon="el-icon-stopwatch"
                  title="Approval Status"
                ></el-step>
                <el-step
                  icon="el-icon-stopwatch"
                  class="cust-fsize12"
                  title="Integration"
                ></el-step>
                <el-step
                  class="cust-fsize12"
                  icon="el-icon-stopwatch"
                  title="Delivered"
                ></el-step>
              </el-steps>
            </div>
          </div>
        </div>
        <div class="w-full flex justify-end mt-6">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="
              (value) => {
                currentPage = value;
                getAll();
              }
            "
            :per-size="perPage"
            :total="totalUsers"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Templatedrawer from "./components/Template-drawer.vue";
import { mapState } from "vuex";
const debounce = function debounce(func, wait = 800) {
  let debounceTimer;
  return function (...args) {
    if (debounceTimer) clearTimeout(debounceTimer);
    const context = this;
    debounceTimer = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
};
export default {
  components: {
    Templatedrawer,
  },
  data() {
    return {
      taskList: [],
      input: "",
      Title: "",
      templateBody: "",
      status: "",
      drawer: false,
      smsTemplates: [],
      centerDialogVisible: false,
      defaultSmsTemps: [],
      totalUsers: 0,
      currentPage: 1,
      perPage: 10,
      totalUsers2: 0,
      currentPage2: 1,
      perPage2: 10,
      templateName: "",
      templateName2: "",
      IsShowSMS: false,
      type: "",
      types: [
        {
          label: "Default",
        },
        {
          label: "Custom",
        },
      ],
    };
  },
  watch: {
    templateName: debounce(async function () {
      this.getAll();
    }),
    templateName2: debounce(async function () {
      this.getDefaultSmsTemplates();
    }),
    type(val) {
      if (val) {
        this.$store.commit("controlCenter/SMS_TYPE", this.type);
      }
    },
  },
  mounted() {
    this.allGetAll();
    this.getAll();
    this.getDefaultSmsTemplates();
    this.getTaskList();
  },
  computed: {
    ...mapState("admin", ["selectedPlan"]),
    ...mapState("defaultTemplates", ["SMS_TEMPLATES"]),
    ...mapState("controlCenter", ["smsType"]),
  },
  methods: {
    async getTaskList() {
      return new Promise(async (resolve, reject) => {
        try {
          // const { data } = await Repository.post(
          //   "/zoho/projects/tasks/tasklist"
          // );
          // console.log(data);

          const { data } = await this.$store.dispatch("builder/getTasklist", {
            // projectName: "testApplication1",
            projectName: process.env.VUE_APP_COMMUNITY_NAME,
          });

          this.taskList = data.map((x) => ({
            text:
              x.name == "Sprint 0" || x.name == "Version 0"
                ? "Default"
                : x.name,
            value: x,
          }));

          // console.log(this.taskList);
          this.$store.commit("marcom/GET_TASK_LIST", {
            key: "taskListUsers",
            value: this.taskList[0].value,
          });

          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
    preview(data) {
      this.IsShowSMS = true;
      this.Title = data.templateName;
      this.status = data.status;
      this.templateBody = data.smsBody ? data.smsBody : data.body;
    },
    sidebarOpen() {
      if (this.selectedPlan[0].subscription.name === "Free") {
        this.centerDialogVisible = true;
        errors.clear();
      } else {
        this.drawer = true;
      }
    },
    async getAll() {
      let payload = {
        paginated: true,
        perPage: this.perPage,
        page: this.currentPage,
      };
      if (this.templateName) {
        Object.assign(payload, { templateName: this.templateName });
      }
      let data = await this.$store.dispatch("controlCenter/getAllSms", payload);
      this.smsTemplates = data.data.recordData;
      this.totalUsers = data.data.recordLength;
      this.drawer = false;
      this.type = this.smsType;
      // console.log(data);
    },
    async allGetAll() {
      let payload = {};
      if (this.templateName) {
        Object.assign(payload, { templateName: this.templateName });
      }
      let data = await this.$store.dispatch(
        "controlCenter/allgetAllSms",
        payload
      );
      this.allTemplates = data.data.recordDataG;
      this.totalUsers = data.data.recordLength;
      this.drawer = false;
      // console.log(data);
    },
    async getDefaultSmsTemplates() {
      let payload = {
        isDeleted: false,
        paginated: true,
        perPage: this.perPage2,
        page: this.currentPage2,
      };
      if (this.templateName2) {
        Object.assign(payload, { templateName: this.templateName2 });
      }
      let data = await this.$store.dispatch("defaultTemplates/getSms", payload);
      this.defaultSmsTemps = data.data.recordData;
      this.totalUsers2 = data.data.recordLength;
    },
  },
};
</script>
